export default __webpack_public_path__ + "static/media/caterpillar.033dbb83.svg";